<template>

  <aside class="CaseStudyCarousel">

    <CarouselNavigationWrapper @activateNextItem="activateNextItem" @activatePrevItem="activatePrevItem">
      <CarouselItemsScroller v-if="content.caseStudies && content.caseStudies.length > 0"
        :numItems="content.caseStudies.length"
        :targetItemIndex="activeItemIndex"
      >
        <CaseStudy v-for="caseStudy in content.caseStudies"
          :key="caseStudy._key"
          :content="caseStudy"
          class="caseStudy"
        />
      </CarouselItemsScroller>
    </CarouselNavigationWrapper>

    <Container v-if="content.caseStudies && content.caseStudies.length > 0" class="indicatorContainer">
      <CarouselItemsIndicator :items="content.caseStudies" v-bind="{ activeItemIndex }" />
    </Container>

  </aside>
</template>

<script setup>

import { ref } from 'vue'

import CaseStudy from '../elems/CaseStudy.vue'
import CarouselItemsIndicator from '../elems/CarouselItemsIndicator.vue'
import CarouselItemsScroller from '../elems/CarouselItemsScroller.vue'
import CarouselNavigationWrapper from '../elems/CarouselNavigationWrapper.vue'

const activeItemIndex = ref(0)
const { content } = defineProps({ content: Object })

function activateNextItem() {
  if (activeItemIndex.value == content.caseStudies.length - 1) {
    activeItemIndex.value = 0
  }
  else {
    activeItemIndex.value += 1
  }
}

function activatePrevItem() {
  if (activeItemIndex.value == 0) {
    activeItemIndex.value = content.caseStudies.length - 1
  }
  else {
    activeItemIndex.value -= 1
  }
}
</script>

<style scoped>

.CaseStudyCarousel {
  padding-bottom: var(--spacing-12);
}

.caseStudy {
  border: thin solid #e7e7e7;
}

.indicatorContainer {
  margin-top: var(--spacing-10);
}

@media (--screen-lg) {

  .caseStudy {
    width: 80rem;
  }
}
</style>
